<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            
        </section>
  
            <!-- Main content -->
            <section class="content">
                <div id="accidentReport" class="box">
                    
                    <div class="box-body" style="min-height:400px;">
                        <h2><strong>Accident Report Submitted</strong></h2>
                        <h5>You've submitted an accident report for accident id: <strong>{{this.$props.accident.accidentId}}</strong></h5>
                        <hr>
                         <p style="font-size: 9pt;"> <strong>We will have an agent get in contact with you on the next steps shortly. If you need to speak with one of our support specialists now, please call  1-(888)-333-4444</strong>.<br><br>
                    <strong>If this is an emergency, please call <span style="color:red;">911</span> immediately.</strong></p>
                    <hr>
                    <h4>Accident Information</h4>
                    <br>
<div class="form-group"> 
                        
                                <label for="inputPassword">Time Submitted: </label>
                                <p id="inputPassword" >{{this.formattedTimeSubmitted}}</p> </div>
                        
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Accident Name: </label>
                                <p id="inputPassword" >{{this.$props.accident.accidentName}}</p> </div>
                    
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Vehicle Make: </label>
                                <p id="inputPassword" >{{this.$props.accident.vehicleMake}}</p> </div>
                        
                    
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Vehicle Model: </label>
                                <p id="inputPassword" >{{this.$props.accident.vehicleModel}}</p> 
                        
                    </div>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Vehicle Year: </label>
                                <p id="inputPassword" >{{this.$props.accident.vehicleYear}}</p> 
                        
                    </div>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Vehicle speed at time of impact: </label>
                                <p id="inputPassword" v-if="this.$props.accident.vehicleSpeed" >{{this.$props.accident.vehicleSpeed}} MPH</p> 
                                <p id="inputPassword" v-else >No Value Entered</p> 
                        
                    </div>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Type of Accident: </label>
                                <p id="inputPassword" >{{this.$props.accident.accidentType}}</p> 
                        
                    </div>
                    <div class="form-group"> 
                        
                                <label for="inputPassword">Time of Accident: </label>
                                <p id="inputPassword" >{{this.$props.accident.accidentDate}} {{this.$props.accident.accidentTime}}</p> 
                        
                    </div>
                    
                     <div class="form-group"> 
                        
                                <label for="inputPassword">Location of Accident: </label>
                                <p id="inputPassword" >{{this.$props.accident.accidentLocation}}</p> 
                        
                    </div>
                     
                    <div class="form-group"> 
                        
                                <label for="inputPassword">Additional Info: </label>
                                <p id="inputPassword" >{{this.$props.accident.additionalInformation}}</p> 
                        
                    </div>
                    <br>
      <div class="form-group"> 
                        <h4 for="inputPassword"><strong>Services Needed </strong></h4>
                        <hr>
                        <div v-if="this.$props.accident.servicesNeeded.length > 0">
                                <p v-for="service in this.$props.accident.servicesNeeded">
                                    <span style="vertical-align: top;">{{service}} </span>
                                </p>
                        </div>
      </div>
      <hr>
                    <div class="form-group"> 
                        <h4 for="inputPassword"><strong>Uploaded Files </strong></h4>
                        <hr>
                        <div v-if="this.$props.accident.successfulFiles.length > 0">
                                <h5 style="font-size:9pt;"><strong>List of files uploaded successfully:</strong> </h5>
                                <p v-for="fileObj in this.$props.accident.successfulFiles">
                                   <i class="material-icons" style="color:green;">check_circle</i> <span style="vertical-align: top;">{{fileObj.file.name}}</span>
                                </p>
                        </div>
                        <div v-if="this.$props.accident.unsuccessfulFiles.length > 0">
                                 <h5 style="font-size:9pt;"><strong>List of files failed to upload:</strong> </h5>
                                
                                <p  v-for="fileObj in this.$props.accident.unsuccessfulFiles">
                                  <span> <i class="material-icons" style="color:red;">error</i> {{fileObj.file.name}} </span>
                                </p>
                        </div>
                        
                        <hr>
                    </div>
                    <br>
                    <br>
                    <hr>
                                <div class="col-md-12 row-block"> <a  class="btn btn-primary btn-block"  v-on:click="submitReport">Go Back to Main Page</a> </div>

                    <hr>
                    <br>
                    <br>
                    <br>
                    <br>
                    <p style="font-size: 9pt;"> We will have an agent get in contact with you on the next steps shortly. If you need to speak with one of our support specialists now, please call <strong>1-(888)-333-4444</strong>.<br><br>
                    <strong>If this is an emergency, please call 911 immediately.</strong></p>
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
const google = require('../services/google')
const jwt_decode = require('jwt-decode');
const to = require('await-to-js').default
  export default {
    name: 'AccidentReportSubmitted',
    props:['accident'],
    data(){
        return{
            formattedTimeSubmitted: ''
        }
    },
    beforeMount(){
        if (window.localStorage) {
            console.log("HERE IN BM")
    this.firstName = localStorage.getItem(cliStorNames.FIRST_NAME.name)
     this.lastName = localStorage.getItem(cliStorNames.LAST_NAME.name)
      this.city = localStorage.getItem(cliStorNames.CITY.name)
       this.email = localStorage.getItem(cliStorNames.EMAIL.name)
     this.phone = localStorage.getItem(cliStorNames.PHONE.name)
      this.state = localStorage.getItem(cliStorNames.STATE.name)
       this.zipcode = localStorage.getItem(cliStorNames.ZIPCODE.name)
                    console.log(this.zipcode)

        } 
               this.userId = this.$cookie.get(cliStorNames.USER_ID.name)

},
mounted(){
        this.sendEmail()

},
//need to clear fro local str maybe
    created(){
       
        var timeSubmitted = this.$props.accident.timeSubmitted
        var date = new Date(timeSubmitted)
        this.formattedTimeSubmitted = date
        if (window.localStorage) {
                console.log("user FirstName", this.$route.params.user.firstName)
                               

                if (!localStorage.getItem(cliStorNames.ACCIDENT_ID.name)){
                localStorage.setItem(cliStorNames.ACCIDENT_ID.name, this.$route.params.accident.accidentId)

                }
{
                                if (!localStorage.getItem(cliStorNames.ACCIDENT_TIME.name))
                localStorage.setItem(cliStorNames.ACCIDENT_TIME.name, this.$route.params.accident.accidentTime)

}
                if (!localStorage.getItem(cliStorNames.ACCIDENT_TYPE.name)){
                localStorage.setItem(cliStorNames.ACCIDENT_TYPE.name, this.$route.params.accident.accidentType)

                }
                                if (!localStorage.getItem(cliStorNames.TIME_SUBMITTED.name)){
                localStorage.setItem(cliStorNames.TIME_SUBMITTED.name, this.$route.params.accident.timeSubmitted)

                                }
                                if (!localStorage.getItem(cliStorNames.VEHICLE_SPEED.name)){
                                                    localStorage.setItem(cliStorNames.VEHICLE_SPEED.name, this.$route.params.accident.vehicleSpeed)

                                }
                                if (!localStorage.getItem(cliStorNames.VEHICLE_MAKE.name)){
                                                    localStorage.setItem(cliStorNames.STATE.name, this.$route.params.accident.state)

                                }
                                if (!localStorage.getItem(cliStorNames.VEHICLE_MODEL.name)){
                                    
                            
                localStorage.setItem(cliStorNames.VEHICLE_MODEL.name, this.$route.params.accident.vehicleModel)}
                if (!localStorage.getItem(cliStorNames.ADDITIONAL_TEXT.name)){
                                    
                            
                localStorage.setItem(cliStorNames.ADDITIONAL_TEXT.name, this.$route.params.accident.additionalTextInfoArea)}
                    localStorage.setItem(cliStorNames.USER_ID.name, this.$route.params.userId)
        }


    },
    beforeDestroy(){
      
},
methods:
{   
    submitReport: function(){
  localStorage.removeItem(cliStorNames.ACCIDENT_ID.name)
      localStorage.removeItem(cliStorNames.ACCIDENT_TYPE.name)
      localStorage.removeItem(cliStorNames.ACCIDENT_TIME.name)
       localStorage.removeItem(cliStorNames.ACCIDENT_LOCATION.name)
     localStorage.removeItem(cliStorNames.VEHICLE_SPEED.name)
      localStorage.removeItem(cliStorNames.VEHICLE_MAKE.name)
        localStorage.removeItem(cliStorNames.VEHICLE_MODEL.name)
     localStorage.removeItem(cliStorNames.VEHICLE_YEAR.name)
          localStorage.removeItem(cliStorNames.ADDITIONAL_TEXT.name)

          this.$router.push('/')

    },
  sendEmail: async function(){
        try{
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        var decodedHeader = jwt_decode(userToken);
        let userEmail = decodedHeader.email
                console.log($( '#accidentReport' ))

        console.log(document.getElementById( 'accidentReport' ))
       const emailText =  $( '#accidentReport' )[0].innerText
        const emailMsg =  $( '#accidentReport' )[0].innerHTML.toString().replaceAll('<p id="inputPassword">','<p id="inputPassword"><strong>').replaceAll("</p>", "</strong></p>") //document.getElementById( 'accidentReport' )
        console.log("email", emailMsg)
        const [msgErr, msgRes] = await to(google.sendMessage({
      To: userEmail,
      Subject: "Accident Report for: " + this.firstName + " " + this.lastName,
      Message: emailMsg,
      MessageText: emailText,
      userToken
    }, {}));
        
        if(msgErr){
            console.error(msgErr)
            throw msgErr
        }

let msg2Err, msg2Res;
[msg2Err, msg2Res] = await to(google.sendMessage({
      To: 'wearefendr@gmail.com',
      Subject: "Full Accident Report for: " + this.firstName + " " + this.lastName,
      Message: emailMsg + "<hr><br><br><br><strong><h1>User Details: </h1></strong><p><strong>First Name:</strong>&nbsp;" + this.firstName + "</p><p><strong>Last Name:</strong>&nbsp;" + this.lastName + "</p><p><strong>City:</strong>&nbsp;" + this.city + "</p><p><strong>State:</strong>&nbsp;" + this.state  + "</p><p><strong>Zipcode:</strong>&nbsp;" + this.zipcode + "</p>",
      MessageText: emailText,
      userToken
    }, {}));
        
        if(msg2Err){
            console.error(msg2Err)
            throw msg2Err
        }

        
     console.log(msg2Res)
     
     }

     
        catch(err){
            console.error(err)
            this.$confirm("Can't send report VIA email at this time, but don't worry, you can still view the records in your account.", "Email Confirmation Error", 
             {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'})
            
        }
    }
  
}
  }
</script>



// WEBPACK FOOTER //
// AccidentReportSubmitted.vue?15945048